  (() => {
    if (window.BeeCollectionStoryShareReady) return;
    window.BeeCollectionStoryShareReady = true;

    function absoluteUrl(url) {
      return url ? new URL(url, window.location.origin).href : window.location.href;
    }

    function loadImage(url) {
      return new Promise((resolve, reject) => {
        if (!url) {
          reject(new Error('Image URL is empty'));
          return;
        }

        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = absoluteUrl(url);
      });
    }

    function roundedRect(context, x, y, width, height, radius) {
      const r = Math.min(radius, width / 2, height / 2);
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + width, y, x + width, y + height, r);
      context.arcTo(x + width, y + height, x, y + height, r);
      context.arcTo(x, y + height, x, y, r);
      context.arcTo(x, y, x + width, y, r);
      context.closePath();
    }

    function drawCover(context, image, x, y, width, height) {
      const scale = Math.max(width / image.width, height / image.height);
      const renderedWidth = image.width * scale;
      const renderedHeight = image.height * scale;
      context.drawImage(image, x + (width - renderedWidth) / 2, y + (height - renderedHeight) / 2, renderedWidth, renderedHeight);
    }

    function drawContain(context, image, x, y, width, height) {
      const scale = Math.min(width / image.width, height / image.height);
      const renderedWidth = image.width * scale;
      const renderedHeight = image.height * scale;
      context.drawImage(image, x + (width - renderedWidth) / 2, y + (height - renderedHeight) / 2, renderedWidth, renderedHeight);
    }

    function textLines(context, text, maxWidth, maxLines) {
      const words = String(text || '').split(/\s+/).filter(Boolean);
      const lines = [];
      let line = '';
      let truncated = false;

      words.forEach((word) => {
        const test = line ? `${line} ${word}` : word;
        if (context.measureText(test).width <= maxWidth || !line) {
          line = test;
        } else if (lines.length < maxLines - 1) {
          lines.push(line);
          line = word;
        } else {
          truncated = true;
        }
      });

      if (line && lines.length < maxLines) lines.push(line);
      if (truncated && lines.length) lines[lines.length - 1] = `${lines[lines.length - 1]}…`;
      return lines;
    }

    function collectionData(root) {
      let products = [];
      const json = root.querySelector('[data-collection-story-products]');

      if (json) {
        try {
          products = JSON.parse(json.textContent || '[]');
        } catch (error) {
          products = [];
        }
      }

      return {
        title: (root.dataset.collectionTitle || 'Kataloq').trim(),
        url: absoluteUrl(root.dataset.collectionUrl || ''),
        count: Number(root.dataset.collectionCount || products.length || 0),
        products: products.slice(0, 9)
      };
    }

    function showStatus(root, message) {
      const status = root.querySelector('[data-collection-story-status]');
      if (!status) return;

      const trigger = root.querySelector('[data-collection-story-button]');
      if (trigger) {
        positionFloating(trigger, status, 230, '--bcss-status-left', '--bcss-status-top');
      }

      status.textContent = message;
      window.setTimeout(() => {
        status.textContent = '';
        status.style.removeProperty('--bcss-status-top');
        status.style.removeProperty('--bcss-status-left');
      }, 2200);
    }

    function closeMenus() {
      document.querySelectorAll('[data-collection-story-menu]:not([hidden])').forEach((menu) => {
        menu.hidden = true;
        menu.style.removeProperty('--bcss-menu-top');
        menu.style.removeProperty('--bcss-menu-left');
        const root = menu.closest('[data-collection-story-share]');
        const button = root && root.querySelector('[data-collection-story-button]');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    function positionFloating(trigger, element, preferredWidth, leftVar, topVar) {
      const triggerRect = trigger.getBoundingClientRect();
      const elementWidth = Math.min(preferredWidth, window.innerWidth - 24);
      const gap = 10;
      const safe = 12;

      let left = triggerRect.left;
      let top = triggerRect.bottom + gap;

      if (left + elementWidth > window.innerWidth - safe) {
        left = window.innerWidth - safe - elementWidth;
      }

      if (left < safe) {
        left = safe;
      }

      element.style.setProperty(leftVar, `${Math.round(left)}px`);
      element.style.setProperty(topVar, `${Math.round(top)}px`);
    }

    function positionMenu(trigger, menu) {
      positionFloating(trigger, menu, 218, '--bcss-menu-left', '--bcss-menu-top');
    }

    async function copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();
    }

    function drawHeader(context, data, font) {
      context.fillStyle = '#fff';
      context.fillRect(0, 0, 1080, 1920);

      context.fillStyle = '#faf4ef';
      context.beginPath();
      context.arc(-90, 96, 360, 0, Math.PI * 2);
      context.fill();

      context.fillStyle = '#f8eee7';
      context.beginPath();
      context.arc(1080, 1640, 440, 0, Math.PI * 2);
      context.fill();

      roundedRect(context, 58, 62, 204, 58, 29);
      context.fillStyle = 'rgba(217, 96, 13, 0.10)';
      context.fill();
      context.fillStyle = '#d9600d';
      context.beginPath();
      context.arc(90, 91, 16, 0, Math.PI * 2);
      context.fill();
      context.fillStyle = '#fff';
      context.font = `900 20px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('↗', 90, 90);

      context.textAlign = 'left';
      context.fillStyle = '#8a4a12';
      context.font = `700 24px ${font}`;
      context.fillText('Kataloq seçimi', 118, 93);

      context.save();
      context.shadowColor = 'rgba(111, 31, 48, 0.08)';
      context.shadowBlur = 18;
      context.shadowOffsetY = 8;
      roundedRect(context, 684, 58, 258, 62, 31);
      context.fillStyle = 'rgba(255, 255, 255, 0.92)';
      context.fill();
      context.shadowColor = 'transparent';
      context.shadowBlur = 0;
      context.shadowOffsetY = 0;
      context.fillStyle = '#6f1f30';
      context.font = `900 30px ${font}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('royal.az', 813, 86);
      context.fillStyle = '#a25b26';
      context.font = `700 13px ${font}`;
      context.fillText('musiqi alətləri', 813, 106);
      context.restore();
      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';

      context.fillStyle = '#201c1a';
      context.font = `800 56px ${font}`;
      const titleLines = textLines(context, data.title, 860, 2);
      titleLines.forEach((line, index) => context.fillText(line, 58, 186 + index * 64));

      context.fillStyle = '#81756c';
      context.font = `600 25px ${font}`;
      const count = data.count ? `${data.count} məhsul` : 'Seçilmiş məhsullar';
      context.fillText(count, 58, 326);
    }

    async function drawProductCard(context, product, index, font) {
      const columns = 3;
      const tileWidth = 300;
      const tileHeight = 380;
      const gapX = 34;
      const gapY = 46;
      const startX = 56;
      const startY = 410;
      const col = index % columns;
      const row = Math.floor(index / columns);
      const x = startX + col * (tileWidth + gapX);
      const y = startY + row * (tileHeight + gapY);

      context.save();

      context.fillStyle = row % 2 === 0 ? 'rgba(250, 244, 239, 0.42)' : 'rgba(255, 255, 255, 0.18)';
      context.beginPath();
      context.ellipse(x + tileWidth / 2, y + 92, 124, 76, 0, 0, Math.PI * 2);
      context.fill();

      if (product.image) {
        try {
          const image = await loadImage(product.image);
          drawContain(context, image, x + 18, y, tileWidth - 36, 180);
        } catch (error) {}
      }
      context.restore();

      context.fillStyle = '#8d8580';
      context.font = `750 18px ${font}`;
      context.fillText(product.vendor || 'ROYAL', x + 4, y + 218);

      context.fillStyle = '#211f20';
      context.font = `850 25px ${font}`;
      const nameLines = textLines(context, product.title || 'Məhsul', tileWidth - 8, 2);
      nameLines.forEach((line, lineIndex) => context.fillText(line, x + 4, y + 252 + lineIndex * 30));

      const priceY = y + 338;
      context.fillStyle = '#ff6600';
      context.font = `900 27px ${font}`;
      context.fillText(product.price || '', x + 4, priceY);

      if (product.comparePrice) {
        const priceWidth = context.measureText(product.price || '').width;
        const compareX = x + 16 + priceWidth;
        const compareY = priceY - 2;
        context.fillStyle = '#aaa3a0';
        context.font = `700 19px ${font}`;
        context.fillText(product.comparePrice, compareX, compareY);
        const compareWidth = context.measureText(product.comparePrice).width;
        context.beginPath();
        context.moveTo(compareX, compareY - 8);
        context.lineTo(compareX + compareWidth, compareY - 8);
        context.strokeStyle = 'rgba(150, 142, 138, 0.95)';
        context.lineWidth = 3;
        context.lineCap = 'round';
        context.stroke();
      }
    }

    async function createCollectionStoryFile(data) {
      const canvas = document.createElement('canvas');
      canvas.width = 1080;
      canvas.height = 1920;
      const context = canvas.getContext('2d');
      const font = 'Quicksand, -apple-system, BlinkMacSystemFont, sans-serif';

      drawHeader(context, data, font);

      const products = data.products.slice(0, 9);
      for (let index = 0; index < products.length; index += 1) {
        await drawProductCard(context, products[index], index, font);
      }

      const actionY = 1800;
      roundedRect(context, 58, actionY, 360, 78, 39);
      const gradient = context.createLinearGradient(58, actionY, 418, actionY + 78);
      gradient.addColorStop(0, '#e9872d');
      gradient.addColorStop(1, '#d9600d');
      context.fillStyle = gradient;
      context.fill();
      context.fillStyle = '#ffffff';
      context.font = `900 25px ${font}`;
      context.fillText('KATALOQA BAX', 98, actionY + 49);

      context.fillStyle = '#a3968d';
      context.font = `600 22px ${font}`;
      context.textAlign = 'right';
      context.fillText('Royal · Musiqi alətləri mağazası', 1018, 1850);
      context.textAlign = 'left';

      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Collection story failed')), 'image/png', 0.95);
      });
      return new File([blob], 'royal-collection-story.png', { type: 'image/png' });
    }

    async function handleShareClick(event) {
      const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      if (!target) return;

      const trigger = target.closest('[data-collection-story-button]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const root = trigger.closest('[data-collection-story-share]');
        const menu = root && root.querySelector('[data-collection-story-menu]');
        if (!root || !menu) return;

        const willOpen = menu.hidden;
        closeMenus();

        if (willOpen) {
          positionMenu(trigger, menu);
          menu.hidden = false;
        } else {
          menu.hidden = true;
        }

        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      const option = target.closest('[data-collection-share-kind]');
      if (option) {
        event.preventDefault();
        event.stopPropagation();

        const root = option.closest('[data-collection-story-share]');
        if (!root) return;

        const menu = root.querySelector('[data-collection-story-menu]');
        if (menu) menu.hidden = true;
        const triggerButton = root.querySelector('[data-collection-story-button]');
        if (triggerButton) triggerButton.setAttribute('aria-expanded', 'false');

        const data = collectionData(root);
        const kind = option.dataset.collectionShareKind;
        const text = `${data.title} — Royal.az`;

        if (kind === 'instagram') {
          showStatus(root, 'Story hazırlanır…');
          try {
            const file = await createCollectionStoryFile(data);
            if (navigator.share && (!navigator.canShare || navigator.canShare({ files: [file] }))) {
              await navigator.share({ files: [file], title: data.title, text });
            } else {
              const download = document.createElement('a');
              download.href = URL.createObjectURL(file);
              download.download = file.name;
              document.body.appendChild(download);
              download.click();
              download.remove();
              window.setTimeout(() => URL.revokeObjectURL(download.href), 1000);
              showStatus(root, 'Story şəkli endirildi');
            }
          } catch (error) {
            showStatus(root, 'Story hazırlamaq olmadı');
          }
        } else if (kind === 'native') {
          if (navigator.share) {
            try {
              await navigator.share({ title: data.title, text, url: data.url });
            } catch (error) {}
          } else {
            try {
              await copyToClipboard(data.url);
              showStatus(root, 'Link kopyalandı');
            } catch (error) {
              window.open(data.url, '_blank', 'noopener');
            }
          }
        } else if (kind === 'whatsapp') {
          window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${data.url}`)}`, '_blank', 'noopener');
        } else if (kind === 'copy') {
          try {
            await copyToClipboard(data.url);
            showStatus(root, 'Link kopyalandı');
          } catch (error) {
            showStatus(root, 'Linki kopyalamaq olmadı');
          }
        }
        return;
      }

      closeMenus();
    }

    document.addEventListener('click', handleShareClick, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenus();
    });
  })();
